import { BranchesOutlined } from '@ant-design/icons';
import { Button, ButtonProps, Space } from 'antd';
import * as React from 'react';
import { useState } from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';

import { Drawer } from '@framework/ui';
import { IReference } from '../../../schema/expressions/references/IReference';
import { ConditionGroupExpressionSchema } from '../../../schema/expressions/repository/condition-group/ConditionGroupExpressionSchema';
import { IConditionGroupExpression } from '../../../schema/expressions/repository/condition-group/IConditionGroupExpression';
import { ConditionGroupInput } from '../../../schema/expressions/repository/condition-group/input/ConditionGroupInput';
import { DrawerButtonRow } from '../../../ui/drawer/DrawerButtonRow';

export interface IConditionsEditorInputProps {
  name: string;
  references: IReference[];
  size?: ButtonProps['size'];
}

export function ConditionsEditorInput(props: IConditionsEditorInputProps) {
  const { name, references, size } = props;
  const [isOpen, setIsOpen] = useState(false);

  const methods = useFormContext();
  const { field } = useController({
    name,
    defaultValue: null,
  });

  const value = useWatch({ name }) as IConditionGroupExpression | null;

  return (
    <>
      <Button
        size={size}
        type={value != null ? 'primary' : 'default'}
        icon={<BranchesOutlined />}
        onClick={() => {
          // Inizializziamo l'espressione, perché premendo sul tasto regole
          // senza aver mai aperto il drawer, il valore è null.
          // In questo modo facciamo corrispondere l'apertura del drawer
          // alla valorizzazione del campo.
          if (value == null) {
            field.onChange(
              ConditionGroupExpressionSchema.cast({}, { assert: false }),
            );
          }

          setIsOpen(true);
        }}
      >
        Regole
      </Button>
      <Drawer
        title="Regole di visualizzazione"
        size="large"
        placement="right"
        open={isOpen}
        onClose={() => setIsOpen(false)}
      >
        {value != null && (
          <ConditionGroupInput name={name} references={references} />
        )}
        <DrawerButtonRow>
          <Space>
            <Button
              size="large"
              danger
              onClick={() => {
                field.onChange(null);
                field.onBlur();
                setIsOpen(false);
              }}
            >
              Rimuovi
            </Button>
            <Button
              size="large"
              type="primary"
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onClick={async () => {
                // Permette di validare il form prima di chiudere il drawer,
                // in modo da mostrare gli errori.
                const isValid = await methods.trigger(name, {
                  shouldFocus: true,
                });

                if (isValid) {
                  setIsOpen(false);
                }
              }}
            >
              Applica
            </Button>
          </Space>
        </DrawerButtonRow>
      </Drawer>
    </>
  );
}
